export const comments_4791873 = {"data":{"data":[],"links":{}}}